import { ChakraBox, ChakraText } from '@equip.health/ui';

import { PAGE_LAYOUT } from '~/lib/constants';

const PageNotFound = () => (
  <ChakraBox
    alignItems="center"
    display="flex"
    justifyContent="center"
    paddingRight={PAGE_LAYOUT.rightSpacing}
  >
    <ChakraText>
      Page not found! Please check that the URL entered is correct.
    </ChakraText>
  </ChakraBox>
);

export default PageNotFound;
